import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'striphtml',
    standalone: false
})
export class StripHtmlPipe implements PipeTransform {
  transform(value: string): any {
    return value.replace(/<.*?>/g, ''); // replace tags
  }
}
